/** Group tenge without losing tiyn or turning missing values into zero. */
export function formatFinancialInput(raw: string): string {
  let value = raw.replace(/,/g, '.').replace(/[^\d.]/g, '');
  const dot = value.indexOf('.');
  if (dot !== -1) value = value.slice(0, dot + 1) + value.slice(dot + 1).replace(/\./g, '');
  const [whole, fractional] = value.split('.');
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');
  return fractional === undefined ? grouped : `${grouped}.${fractional.slice(0, 2)}`;
}

export function formatFinancialValue(value: number | null | undefined): string {
  return value == null || !Number.isFinite(value) || value < 0 ? ''
    : formatFinancialInput(value.toLocaleString('en-US', { useGrouping: false, maximumFractionDigits: 2 }));
}

/** A blank field is unknown; a typed zero is an explicit financial value. */
export function isFinancialInputComplete(value: string): boolean {
  const normalized = value.replace(/[\u00a0\s]/g, '').replace(',', '.');
  return /^(?:\d+(?:\.\d{0,2})?|\.\d{1,2})$/.test(normalized) && Number.isFinite(Number(normalized));
}
